import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { useFilters } from "@/state/FilterContext";

export function useDashboardData(endpoint, extraParams = {}) {
  const { queryParams } = useFilters();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    http
      .get(endpoint, { params: { ...queryParams(), ...extraParams } })
      .then((r) => {
        if (!active) return;
        setData(r.data);
        setError(null);
      })
      .catch((e) => active && setError(e))
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
    // eslint-disable-next-line
  }, [endpoint, JSON.stringify(queryParams()), JSON.stringify(extraParams)]);

  return { data, loading, error };
}
